export const DB_PREFIX_MANDATORY = 'mandatoryCourses';
export const DB_PREFIX_EXTRA = 'extraCourses';
